import React from 'react';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';

import classNames from 'classnames';

import '../css/ReactBeautifulDndHandler.less';

import { SatCoreRegister } from '../SatCoreRegistry';

const ReactBeautifulDndHandler = ({
  enabled,
  onReorder,
  children,
  contextClassName = '',
  droppableClassName = '',
  droppableId = 'default-droppable-list',
  t,
  tReady,
  ...props
} = {}) => {
  const handleOnDragEnd = async (result) => {
    if (!result.destination || !onReorder) {
      return;
    }
    const { source, destination } = result;
    if (source.index === destination.index) {
      return;
    }
    await onReorder(result);
  };

  // if drag-drop is not enabled, just render children as-is
  if (!enabled) {
    return children;
  }
  // else if enabled, wrap with drag-drop context
  return (
    <DragDropContext onDragEnd={handleOnDragEnd}>
      <Droppable droppableId={droppableId}>
        {(provided, snapshot) => {
          return (
            <div
              {...provided.droppableProps}
              ref={provided.innerRef}
              className={classNames(droppableClassName, {
                'dragging-over': snapshot.isDraggingOver
              })}
              {...props}>
              {children}
              {provided.placeholder}
            </div>
          );
        }}
      </Droppable>
    </DragDropContext>
  );
};

SatCoreRegister('ReactBeautifulDndHandler', ReactBeautifulDndHandler);

export default ReactBeautifulDndHandler;
